<template>
  <HScaffold title="投注记录" :hideLeftBackBtn="hideLeftBackBtn">
    <template #header>
      <div :style="{
        backgroundColor: HNewGameUIConfig.newGameUIType === 3?'#1f1f1f':'white',
        padding: '10px',
        borderBottom: HNewGameUIConfig.newGameUIType === 3?'#333 1px solid':'#f6f6f6 1px solid',
      }">
        <div style="display:flex;flex-direction: row;align-items: center;justify-content: space-between">
          <HDatePicker :change="selectDateChange"/>
          <div style="display:flex;flex-direction: row;align-items: center;margin-right: 10px;">
            <van-icon name="filter-o" :color="isShowFilter?hcf.getMainColor():(HNewGameUIConfig.newGameUIType === 3?'#fff':'#333')"/>
            <div @click="switchShowFilter" :style="hcf.getTextStyle({
              color:isShowFilter?'main':'',marginRight:5,
            })">筛选</div>
            <van-checkbox shape="square" icon-size="16px" v-model="isShowFilter"/>
          </div>
        </div>
        <keep-alive>
        <ThreeTags v-if="isShowFilter" :change="selectTagChange" style="margin-top: 10px" reqPath="/game/bet-history/tag"
                    :startSecs="requestStartSecs" :endSecs="requestEndSecs"/>
        </keep-alive>
      </div>
    </template>
    <HList path="/game/bet-history/list" :exParams="requestExParams">
      <template #default="{ item,index }">
        <EachHistory :item="item" :index="index"/>
      </template>
    </HList>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import HDatePicker from "@/components/utils/HDatePicker.vue";
  import HList from "@/components/utils/HList.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import EachHistory from "@/components/pages/BetHisAndDetail/EachHistory.vue";
  import ThreeTags from "@/components/pages/BetHisAndDetail/ThreeTags.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  defineProps(["hideLeftBackBtn"]);

  const useUser = useUserStore();
  const { nowSecs, nDaysAgoSecs } = hcf.getNowAndNDaysAgoStart();
  const requestStartSecs = ref(nDaysAgoSecs);
  const requestEndSecs = ref(nowSecs);

  let selectTagItem1 = null;
  let selectTagItem2 = null;
  let selectTagItem3 = null;

  const isShowFilter = ref(false);

  const requestExParams = ref({
    "UserId": useUser.userId,
    "BeginTime": requestStartSecs.value,
    "EndTime": requestEndSecs,
    "Tag1": [],
    "Tag2": [],
    "Tag3": [],
  });
  function switchShowFilter(){
    isShowFilter.value = !isShowFilter.value;
  }

  function selectDateChange(startSecs, endSecs) {
    requestStartSecs.value = startSecs;
    requestEndSecs.value = endSecs;
    updateExParams();
  }

  function selectTagChange(tagItem1,tagItem2,tagItem3) {
    selectTagItem1 = tagItem1;
    selectTagItem2 = tagItem2;
    selectTagItem3 = tagItem3;
    updateExParams();
  }

  function updateExParams() {
    requestExParams.value = {
      "UserId": useUser.userId,
      "BeginTime": requestStartSecs.value,
      "EndTime": requestEndSecs.value,
      "Tag1": selectTagItem1!=null?[selectTagItem1["Id"]]:[],
      "Tag2": selectTagItem2!=null?[selectTagItem2["Id"]]:[],
      "Tag3": selectTagItem3!=null?selectTagItem3:[],
    };
  }

</script>


<style scoped>


</style>
